import { Component, Input } from '@angular/core';
import {AppAlertService, ParametersService, PopupService, SubtitlesService} from "../../core";
import {PopupBridgeService} from "../../core/popup-bridge.service";
import {AlarmMessage, AlarmMessageData} from "../../models/alarms";
import {AlarmTile, AlarmZoneTile, ModuleData} from "../../models";
import {FormatPipe} from "../../shared";


@Component({
  selector: 'simple-message',
  templateUrl: './simple-message.component.html',
  styleUrls: ['./simple-message.component.scss']
})
export class SimpleMessageComponent {
  @Input() item: AlarmMessage;
  @Input() key: number;

  constructor(
      public subtitles: SubtitlesService,
      private appAlert: AppAlertService,
      public parameters: ParametersService,
      private popupBridge: PopupBridgeService,
      public popup: PopupService,
      private formatPipe: FormatPipe,
  ) {}

  closePopup(key: number): void {
    this.appAlert.closePopup(key);
  }

  switchModule(module: ModuleData, key: number): void {
    this.popupBridge.switchModule(module, key);
  }

  formatAlarmText(data: AlarmMessageData): string {
    const subtitle = this.subtitles.setSubtitle(data.txtId);
    const unit = typeof data.unit === 'number' ? data.unit : 0;
    const valueWithUnit = this.formatPipe.transform(data.value, unit);
    return `${subtitle} ${valueWithUnit}`;
  }
}
